import {
  PolicyContainer,
  PolicyTitle,
  PolicyVersion,
  PolicyText,
  PolicyList,
  PolicySectionTitle,
  PolicyArticleTitle,
  PolicyHyphenList,
} from "styles/PolicyCommon";
import { useEffect } from "react";

const OperationVi = () => {
  useEffect(() => {
    document.documentElement.lang = "vi";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <PolicyTitle>Chính sách Cộng đồng pregnancy&baby</PolicyTitle>
      <PolicyVersion>
        Ngày có hiệu lực: 21 tháng 9 năm 2026
        <br />
        Cập nhật lần cuối: 25 tháng 8 năm 2026
      </PolicyVersion>

      <PolicyText>
        Chính sách Cộng đồng này (“Chính sách”) quy định các nguyên tắc và tiêu
        chuẩn áp dụng khi sử dụng các tính năng cộng đồng của{" "}
        <strong>pregnancy&baby</strong>, dịch vụ do Connecti Co., Ltd. (“Công
        ty”, “chúng tôi”) vận hành.
      </PolicyText>
      <PolicyText>
        Cộng đồng pregnancy&baby là nơi người dùng có thể chia sẻ kinh nghiệm,
        mối quan tâm, câu hỏi và thông tin về chuẩn bị mang thai, điều trị hiếm
        muộn, thai kỳ, sinh con, chăm sóc trẻ và nhiều chủ đề khác.
      </PolicyText>
      <PolicyText>
        Chúng tôi mong muốn pregnancy&baby trở thành một cộng đồng an toàn, lành
        mạnh và tôn trọng lẫn nhau, nơi người dùng có thể thoải mái trao đổi và
        hỗ trợ nhau. Vui lòng đọc và tuân thủ Chính sách này khi sử dụng các
        tính năng cộng đồng.
      </PolicyText>
      <PolicyText>
        Chính sách này bổ sung cho{" "}
        <strong>Điều khoản sử dụng pregnancy&baby</strong>. Nếu hoạt động của
        người dùng vi phạm pháp luật hiện hành, Điều khoản sử dụng hoặc Chính
        sách này, Công ty có thể thực hiện các biện pháp phù hợp, bao gồm hạn
        chế hoặc xóa Nội dung và hạn chế việc sử dụng các tính năng cộng đồng.
      </PolicyText>
      <PolicyText>
        Công ty có thể sửa đổi Chính sách này khi cần thiết để duy trì môi
        trường cộng đồng an toàn và lành mạnh. Những thay đổi quan trọng sẽ được
        thông báo trước thông qua Dịch vụ theo Điều khoản sử dụng và pháp luật
        hiện hành.
      </PolicyText>

      <PolicySectionTitle>
        1. Thông tin hồ sơ đại diện cho bạn
      </PolicySectionTitle>
      <PolicyText>
        Biệt danh và ảnh hồ sơ giúp những người dùng khác nhận biết bạn trong
        cộng đồng.
      </PolicyText>
      <PolicyText>
        Vui lòng sử dụng thông tin hồ sơ phù hợp để thể hiện bản thân.
      </PolicyText>
      <PolicyText>
        Hồ sơ có thể bị hạn chế hoặc yêu cầu thay đổi nếu:
      </PolicyText>
      <PolicyHyphenList>
        <li>
          Chứa nội dung hoặc hình ảnh không phù hợp, phản cảm, khiêu dâm hoặc
          trái pháp luật;{" "}
        </li>
        <li>
          Sử dụng trái phép tên, nhãn hiệu, logo, hình ảnh hoặc tài liệu được
          bảo hộ của cá nhân hoặc tổ chức khác;{" "}
        </li>
        <li>
          Giả mạo người khác, doanh nghiệp, tổ chức, nhân viên hoặc quản trị
          viên của pregnancy&baby; hoặc{" "}
        </li>
        <li>
          Có khả năng gây nhầm lẫn hoặc khiến người dùng khác hiểu sai về danh
          tính hoặc tư cách của người sử dụng.
        </li>
      </PolicyHyphenList>

      <PolicySectionTitle>2. Đăng bài trong cộng đồng</PolicySectionTitle>
      <PolicyText>
        Nội dung được đăng trong cộng đồng pregnancy&baby có thể được các Thành
        viên khác xem.
      </PolicyText>
      <PolicyText>
        Trước khi đăng, vui lòng kiểm tra kỹ xem bài viết hoặc bình luận có chứa
        dữ liệu cá nhân, thông tin riêng tư hoặc thông tin nhạy cảm mà bạn không
        muốn công khai hay không.
      </PolicyText>
      <PolicyText>
        Tất cả bài viết, bình luận, thông tin hồ sơ, hình ảnh và Nội dung khác
        phải tuân thủ Chính sách này và Điều khoản sử dụng pregnancy&baby.
      </PolicyText>

      <PolicySectionTitle>3. Báo cáo Nội dung vi phạm</PolicySectionTitle>
      <PolicyText>
        Nếu bạn phát hiện bài viết hoặc bình luận mà bạn cho rằng vi phạm Chính
        sách này, chẳng hạn như nội dung rác, quảng cáo không được phép, xúc
        phạm, quấy rối, chửi bới hoặc nội dung không phù hợp khác, bạn có thể sử
        dụng tính năng Báo cáo vi phạm trong Dịch vụ.
      </PolicyText>
      <PolicyText>
        Các báo cáo của người dùng giúp chúng tôi duy trì một cộng đồng an toàn
        và tôn trọng hơn.
      </PolicyText>
      <PolicyText>
        Công ty có thể xem xét Nội dung bị báo cáo và thực hiện biện pháp phù
        hợp theo Chính sách này, Điều khoản sử dụng và pháp luật hiện hành.
      </PolicyText>

      <PolicySectionTitle>4. Nội dung và hành vi bị cấm</PolicySectionTitle>
      <PolicyText>
        Các loại Nội dung và hành vi sau không được phép trong cộng đồng
        pregnancy&baby.
      </PolicyText>

      <PolicyArticleTitle>
        4.1 Nội dung tình dục hoặc khiêu dâm
      </PolicyArticleTitle>
      <PolicyText>Không đăng Nội dung:</PolicyText>
      <PolicyHyphenList>
        <li>
          Có mô tả hoặc hình ảnh tình dục quá mức, khiêu dâm hoặc phản cảm;{" "}
        </li>
        <li>
          Quảng bá, mời chào, môi giới hoặc tạo điều kiện cho mại dâm hoặc dịch
          vụ tình dục trái pháp luật;{" "}
        </li>
        <li>
          Nhằm làm nhục, quấy rối hoặc xúc phạm người khác về mặt tình dục;
          hoặc{" "}
        </li>
        <li>
          Có nội dung bóc lột tình dục hoặc nội dung tình dục trái pháp luật
          khác.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.2 Hoạt động hoặc giao dịch trái pháp luật
      </PolicyArticleTitle>
      <PolicyText>Không sử dụng cộng đồng để:</PolicyText>
      <PolicyHyphenList>
        <li>Quảng bá hoặc tạo điều kiện cho cờ bạc trái pháp luật; </li>
        <li>
          Mua bán, trao đổi hoặc mời chào hàng hóa, dịch vụ trái pháp luật;{" "}
        </li>
        <li>
          Bán hoặc quảng bá sản phẩm bị pháp luật cấm bán trên môi trường trực
          tuyến; hoặc{" "}
        </li>
        <li>
          Cung cấp thông tin nhằm khuyến khích, hỗ trợ hoặc tạo điều kiện cho
          hành vi trái pháp luật.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.3 Nội dung có hại, bạo lực hoặc gây phản cảm
      </PolicyArticleTitle>
      <PolicyText>Không đăng Nội dung:</PolicyText>
      <PolicyHyphenList>
        <li>
          Có hình ảnh hoặc mô tả quá mức về thương tích nghiêm trọng, thi thể,
          cái chết hoặc các hình ảnh ghê rợn khác;{" "}
        </li>
        <li>Liên quan đến hoặc tạo điều kiện cho hành vi bóc lột tình dục; </li>
        <li>
          Đe dọa, cưỡng ép, dụ dỗ hoặc lôi kéo người khác nhằm mục đích bóc lột
          tình dục;{" "}
        </li>
        <li>Khuyến khích, cổ súy hoặc ca ngợi bạo lực; </li>
        <li>
          Khuyến khích sự phân biệt đối xử, thù ghét hoặc định kiến đối với cá
          nhân hoặc nhóm người dựa trên quốc tịch, nơi xuất thân, chủng tộc,
          ngoại hình, khuyết tật, bệnh tật, giới tính, bản dạng giới, xu hướng
          tính dục hoặc các đặc điểm cá nhân khác; hoặc{" "}
        </li>
        <li>
          Khuyến khích, hỗ trợ hoặc cổ súy hành vi tự tử hoặc tự tử tập thể.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.4 Quảng cáo, quảng bá và chào mời
      </PolicyArticleTitle>
      <PolicyText>
        Các hoạt động quảng cáo thương mại, quảng bá, chào mời hoặc nội dung rác
        không được Công ty cho phép có thể bị hạn chế hoặc xóa.
      </PolicyText>
      <PolicyText>Bao gồm, nhưng không giới hạn ở:</PolicyText>
      <PolicyHyphenList>
        <li>
          Đăng lặp lại cùng một hoặc nội dung quảng cáo, quảng bá tương tự;{" "}
        </li>
        <li>Bài đăng có mục đích chính là quảng bá sản phẩm hoặc dịch vụ; </li>
        <li>
          Nội dung nhằm dẫn người dùng đến các hoạt động thương mại hoặc giao
          dịch bên ngoài không được phép;{" "}
        </li>
        <li>
          Sử dụng cộng đồng chủ yếu để bán hàng, tìm kiếm khách hàng hoặc tiếp
          thị.
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Công ty không tham gia, bảo đảm hoặc chịu trách nhiệm đối với các giao
        dịch mà người dùng tự nguyện thực hiện với nhau thông qua bài đăng hoặc
        tương tác trong cộng đồng, trừ trường hợp pháp luật có quy định khác.
      </PolicyText>
      <PolicyText>
        Nếu phát hiện hoạt động thương mại hoặc quảng bá đáng ngờ, vui lòng sử
        dụng tính năng Báo cáo vi phạm.
      </PolicyText>

      <PolicyArticleTitle>
        4.5 Quấy rối, xúc phạm, phỉ báng và giả mạo
      </PolicyArticleTitle>
      <PolicyText>Không được:</PolicyText>
      <PolicyHyphenList>
        <li>Liên tục xúc phạm, đe dọa, quấy rối hoặc công kích người khác; </li>
        <li>
          Sử dụng ngôn ngữ quá mức thô tục, hạ nhục, xúc phạm hoặc công kích
          trực tiếp người dùng khác;{" "}
        </li>
        <li>
          Giả mạo pregnancy&baby, Công ty, nhân viên, quản trị viên hoặc người
          khác;{" "}
        </li>
        <li>
          Cung cấp thông tin sai lệch về danh tính hoặc tư cách nhằm lừa dối
          người dùng hoặc thu lợi không chính đáng;{" "}
        </li>
        <li>
          Cố ý phát tán thông tin sai sự thật hoặc gây hiểu nhầm về cá nhân hoặc
          tổ chức theo cách có thể gây thiệt hại; hoặc{" "}
        </li>
        <li>
          Đăng tải Nội dung giả mạo dưới dạng tin tức, bài báo hoặc thông tin
          chính thống nhằm khiến người dùng hiểu nhầm.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.6 Phần mềm độc hại và hành vi gây gián đoạn Dịch vụ
      </PolicyArticleTitle>
      <PolicyText>Không được:</PolicyText>
      <PolicyHyphenList>
        <li>
          Đăng tải, phân phối hoặc liên kết đến vi-rút, phần mềm độc hại, mã độc
          hoặc chương trình nhằm làm hỏng hoặc gây gián đoạn thiết bị hoặc hệ
          thống;{" "}
        </li>
        <li>
          Can thiệp hoặc gây gián đoạn hoạt động bình thường của
          pregnancy&baby;{" "}
        </li>
        <li>Khai thác lỗ hổng của Dịch vụ; hoặc </li>
        <li>
          Sử dụng phương thức tự động hoặc trái phép để phát tán quảng cáo, nội
          dung quảng bá, yêu cầu kết bạn, yêu cầu tương tác hoặc Nội dung tương
          tự.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>4.7 Vi phạm quyền sở hữu trí tuệ</PolicyArticleTitle>
      <PolicyText>
        Vui lòng tôn trọng quyền sở hữu trí tuệ của người khác.
      </PolicyText>
      <PolicyText>Không được:</PolicyText>
      <PolicyHyphenList>
        <li>
          Sử dụng trái phép tác phẩm, nhãn hiệu, thiết kế, hình ảnh hoặc tài
          liệu được bảo hộ của người khác;{" "}
        </li>
        <li>
          Chia sẻ chương trình phát sóng, âm nhạc, phim, hoạt hình, ảnh, hình
          ảnh, bài viết, bài đăng hoặc tác phẩm khác mà không có sự cho phép phù
          hợp;{" "}
        </li>
        <li>
          Cung cấp hướng dẫn hoặc thông tin nhằm tạo điều kiện cho việc truy cập
          hoặc sử dụng trái phép nội dung có bản quyền; hoặc{" "}
        </li>
        <li>
          Sao chép hoặc đăng lại bài viết, ảnh hoặc hình ảnh của người dùng
          pregnancy&baby khác mà không được phép nếu việc đó xâm phạm quyền của
          họ.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.8 Dữ liệu cá nhân và việc chuyển cuộc trò chuyện ra ngoài Dịch vụ
      </PolicyArticleTitle>
      <PolicyText>
        Để bảo vệ quyền riêng tư và sự an toàn của người dùng, không được:
      </PolicyText>
      <PolicyHyphenList>
        <li>
          Yêu cầu dữ liệu cá nhân của người dùng khác thông qua bài viết hoặc
          bình luận;{" "}
        </li>
        <li>
          Công khai dữ liệu cá nhân của bản thân hoặc người khác theo cách có
          thể gây ra rủi ro về quyền riêng tư hoặc an toàn; hoặc{" "}
        </li>
        <li>
          Liên tục hoặc không phù hợp thúc giục người dùng chuyển cuộc trò
          chuyện sang mạng xã hội, ứng dụng nhắn tin hoặc kênh bên ngoài Dịch
          vụ.
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Khi chia sẻ thông tin trong cộng đồng, hãy lưu ý rằng các Thành viên
        khác có thể xem Nội dung đó.
      </PolicyText>

      <PolicyArticleTitle>
        4.9 Nội dung rác và hành vi gây rối cộng đồng
      </PolicyArticleTitle>
      <PolicyText>Không được:</PolicyText>
      <PolicyHyphenList>
        <li>
          Liên tục đăng Nội dung giống nhau hoặc về cơ bản tương tự nhau;{" "}
        </li>
        <li>
          Đăng cùng một hoặc Nội dung tương tự tại nhiều khu vực của Dịch
          vụ;{" "}
        </li>
        <li>Thao túng hoặc lạm dụng các tính năng của Dịch vụ; </li>
        <li>Cố ý cản trở người dùng khác sử dụng Dịch vụ bình thường; hoặc </li>
        <li>
          Thực hiện hành vi khác gây ảnh hưởng nghiêm trọng đến hoạt động bình
          thường của cộng đồng.
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Ngay cả khi một hành vi không được liệt kê cụ thể trong Chính sách này,
        hành vi đó vẫn có thể bị hạn chế nếu rõ ràng làm ảnh hưởng đến sự an
        toàn, tính lành mạnh hoặc hoạt động bình thường của Dịch vụ hoặc gây cản
        trở đáng kể cho việc sử dụng Dịch vụ của người khác.
      </PolicyText>

      <PolicySectionTitle>5. Kiểm duyệt và quản lý Nội dung</PolicySectionTitle>
      <PolicyText>
        Nếu Nội dung vi phạm pháp luật hiện hành, Điều khoản sử dụng
        pregnancy&baby hoặc Chính sách này, Công ty có thể thực hiện một hoặc
        nhiều biện pháp sau:
      </PolicyText>
      <PolicyHyphenList>
        <li>Hạn chế phạm vi hiển thị của Nội dung; </li>
        <li>Tạm thời ẩn Nội dung; </li>
        <li>Xóa Nội dung; </li>
        <li>Hạn chế tính năng đăng bài hoặc bình luận; </li>
        <li>Hạn chế quyền truy cập vào một số tính năng cộng đồng; hoặc </li>
        <li>
          Thực hiện các biện pháp hợp lý khác cần thiết để ngăn chặn hành vi vi
          phạm tiếp diễn hoặc thiệt hại phát sinh thêm.{" "}
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Công ty không có nghĩa vụ kiểm duyệt trước tất cả Nội dung do người dùng
        đăng tải.
      </PolicyText>
      <PolicyText>
        Việc một Nội dung vẫn được hiển thị trong Dịch vụ không có nghĩa là Công
        ty đã phê duyệt, xác nhận, bảo đảm hoặc kiểm chứng tính chính xác của
        Nội dung đó.
      </PolicyText>

      <PolicySectionTitle>
        6. Hạn chế Tài khoản và việc sử dụng Dịch vụ
      </PolicySectionTitle>
      <PolicyText>
        Nếu người dùng vi phạm pháp luật hiện hành, Điều khoản sử dụng hoặc
        Chính sách này, Công ty có thể hạn chế quyền truy cập vào một số tính
        năng hoặc Dịch vụ.
      </PolicyText>
      <PolicyText>
        Tùy thuộc vào tính chất, mức độ nghiêm trọng và tần suất vi phạm, biện
        pháp hạn chế có thể là tạm thời hoặc vĩnh viễn.
      </PolicyText>
      <PolicyText>Các biện pháp có thể bao gồm:</PolicyText>
      <PolicyHyphenList>
        <li>Cảnh báo người dùng; </li>
        <li>Hạn chế phạm vi hiển thị của Nội dung; </li>
        <li>Xóa Nội dung; </li>
        <li>Tạm thời hạn chế quyền đăng bài hoặc bình luận; </li>
        <li>Hạn chế sử dụng các tính năng cộng đồng; </li>
        <li>Tạm khóa Tài khoản; hoặc </li>
        <li>Khóa vĩnh viễn Tài khoản trong trường hợp vi phạm nghiêm trọng.</li>
      </PolicyHyphenList>
      <PolicyText>
        Công ty có thể áp dụng ngay biện pháp cần thiết mà không cần thực hiện
        các bước hạn chế theo thứ tự trong trường hợp có hành vi trái pháp luật
        nghiêm trọng, bóc lột tình dục, cờ bạc trái pháp luật, nguy cơ nghiêm
        trọng đối với an toàn, tấn công ác ý vào Dịch vụ hoặc các hành vi vi
        phạm nghiêm trọng khác.
      </PolicyText>
      <PolicyText>
        Công ty cũng có thể thực hiện các biện pháp bảo vệ hợp lý nếu phát hiện
        hoạt động Tài khoản bất thường, hành vi cố gắng truy cập trái phép, lạm
        dụng tự động hoặc hoạt động khác có khả năng đe dọa người dùng hoặc Dịch
        vụ.
      </PolicyText>

      <PolicySectionTitle>
        7. Khiếu nại và yêu cầu xem xét lại
      </PolicySectionTitle>
      <PolicyText>
        Nếu bạn cho rằng Nội dung hoặc Tài khoản của mình bị hạn chế do nhầm
        lẫn, bạn có thể liên hệ với bộ phận Hỗ trợ khách hàng của pregnancy&baby
        để yêu cầu xem xét lại.
      </PolicyText>
      <PolicyText>
        Công ty sẽ xem xét yêu cầu theo Chính sách này, Điều khoản sử dụng và
        pháp luật hiện hành.
      </PolicyText>
      <PolicyText>
        <strong>Hỗ trợ khách hàng: after10month@connect-i.co.kr</strong>
      </PolicyText>

      <PolicySectionTitle>
        8. Mối quan hệ với Điều khoản sử dụng
      </PolicySectionTitle>
      <PolicyText>
        Chính sách này là một phần của các quy tắc áp dụng đối với việc sử dụng
        pregnancy&baby và được áp dụng cùng với{" "}
        <strong>Điều khoản sử dụng pregnancy&baby</strong>.
      </PolicyText>
      <PolicyText>
        Đối với các vấn đề không được quy định cụ thể trong Chính sách này, việc
        xử lý sẽ được thực hiện theo Điều khoản sử dụng, pháp luật hiện hành và
        các chính sách khác của Công ty có liên quan.
      </PolicyText>
    </PolicyContainer>
  );
};

export default OperationVi;
